import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNextPageParam } from "PFCore/helpers/get_next_page_param";
import { fetchMarketplaceSharedActivities } from "PFCore/services/marketplace/fetch_marketplace_shared";
import {
  MarketplaceActivitiesParams,
  MarketplaceActivitiesResponse
} from "PFCore/services/marketplace/marketplace.types";
import { InfiniteQueryOptions, QueryOptions } from "PFTypes/request_options";

import { activitiesKeys } from "../query_keys";

export const useMarketplaceSharedActivities = (
  params: MarketplaceActivitiesParams,
  options: QueryOptions<MarketplaceActivitiesResponse> = {}
) =>
  useQuery<MarketplaceActivitiesResponse>(
    activitiesKeys.shared(params),
    () => fetchMarketplaceSharedActivities(params),
    options
  );

export const useMarketplaceSharedActivitiesInfinite = (
  params: MarketplaceActivitiesParams,
  options: InfiniteQueryOptions<MarketplaceActivitiesResponse> = {}
) =>
  useInfiniteQuery<MarketplaceActivitiesResponse>({
    queryKey: activitiesKeys.shared(params),
    getNextPageParam,
    queryFn: ({ pageParam = 1 }) => fetchMarketplaceSharedActivities({ ...params, page: pageParam }),
    ...options
  });
